import { Outlet, useNavigate } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { getUser, logout, redirectToLogin } from "../../fetchers/bffClient";
import { ROLES } from "../../models/Permission";

const OPTIMIZELY_EMAIL = /^.+(@optimizely\.com)$/;

function AppLayout() {
  const navigate = useNavigate();

  const loadUser = async () => {
    const session = await getUser();

    if (!session) {
      redirectToLogin();
      return;
    }

    // Mirrors the OptimizelyStaff authorization policy on the API, which is what actually
    // enforces this. Redirecting here only spares a staff-less user a page of failed requests.
    const isSystemAdmin =
      !!session.roles?.includes(ROLES.ADMIN) &&
      OPTIMIZELY_EMAIL.test(session.email);

    if (!isSystemAdmin) {
      navigate("/unauthorize");
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  const handleLogout = useCallback(async () => {
    window.location.assign(await logout());
  }, []);

  useEffect(() => {
    window.addEventListener(
      "@opti-common-header:logout",
      handleLogout as EventListenerOrEventListenerObject
    );

    return () => {
      window.removeEventListener(
        "@opti-common-header:logout",
        handleLogout as EventListenerOrEventListenerObject
      );
    };
  }, [handleLogout]);

  return <Outlet></Outlet>;
}

export default AppLayout;
